import { useEffect, useState } from "react";
import ServiceMenuAccordian from "./ServiceMenuAccordian";
import { CategoryAPI } from "../../../api";

const ServiceMenu = () => {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        CategoryAPI.getAllCategories()
            .then((res) => setCategories(res.data))
            .catch((err) => console.error(err));
    }, []);

    return (
        <div className="space-y-4">
            {categories.map((category, index) => (
                <ServiceMenuAccordian
                    key={index}
                    id={category.id}
                    title={category.title}
                    slug={category.slug}
                    service_items={category.service_items}
                />
            ))}
        </div>
    );
};

export default ServiceMenu;